import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { OcclusionFadeIn } from 'src/style/keyframeUtils'
import { css } from 'styled-components'

interface OcclusionProps {
  className?: string
  fadeIn?: boolean
  isOpen: boolean
  onClick?: () => void
  opacity?: number
}

const Occlusion: React.FC<OcclusionProps> = (props): React.ReactElement => {
  const translate = useTranslate()
  return (
    <div
      className={props.className}
      css={css`
        position: fixed;
        top: 0px;
        width: 100vw;
        height: 100vh;
        background-color: #1e2c4c;
        opacity: 0;
        pointer-events: none;

        ${props.isOpen &&
        css`
          opacity: ${props.opacity || 0.75};
          pointer-events: all;
        `}

        ${props.fadeIn &&
        props.isOpen &&
        css`
          ${OcclusionFadeIn(props.opacity)};
        `}
      `}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex={0}
      aria-label={translate('Close')}
    />
  )
}

export default Occlusion
